import css from '@styled-system/css';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { themeMode } from '../../utils/theme.es.js';
import { Text } from '../Text/Text.es.js';

const Tooltip = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  userSelect: "none",
  textAlign: "center",
  minWidth: "50px"
}, (props) => css({
  borderRadius: "sm",
  py: "xxs",
  px: "sm",
  color: themeMode({
    light: props.isInverted ? "neutral.1000" : "neutral.0",
    dark: props.isInverted ? "neutral.0" : "neutral.1000"
  })(props),
  backgroundColor: themeMode({
    light: props.isInverted ? "neutral.0" : "neutral.1000",
    dark: props.isInverted ? "neutral.1000" : "neutral.0"
  })(props)
}));
const Content = styled(Text)({
  width: "max-content",
  wordBreak: "break-word"
});

export { Content, Tooltip };
//# sourceMappingURL=styled.es.js.map
